import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  Segment,
  Icon,
  Message,
  Divider,
  Button,
  Modal,
} from "semantic-ui-react";
import ReactTable from "react-table";
import "react-table/react-table.css";

import TableFilterButtons from "components/shared/TableFilterButtons";
import { prevButton, nextButton } from "components/shared/TablePagination";

const DeleteModal = (props) => (
  <Modal size="mini" open={props.open}>
    <Modal.Header content="Delete Salesperson" />
    <Modal.Content>
      {props.data ? (
        <p>
          Are you sure you want to delete {props.data.first_name}{" "}
          {props.data.last_name}?
        </p>
      ) : null}
    </Modal.Content>
    <Modal.Actions>
      <Button basic content="Cancel" onClick={props.onModalClose} />
      <Button
        positive
        content="Yes"
        onClick={(e) => props.onDelete(e, props.data.id)}
      />
    </Modal.Actions>
  </Modal>
);

export default class SalespersonTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      tableData: [],
      error: null,
      pages: null,
      activeFilter: 0,
      reqResponse: null,
      modalOpen: false,
      modalData: null,
    };

    this.onFilterButtonClick = this.onFilterButtonClick.bind(this);
    this.onFetchData = this.onFetchData.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.onModalOpen = this.onModalOpen.bind(this);
    this.table = React.createRef();
  }

  onFilterButtonClick(e, filter) {
    e.preventDefault();
    const { activeFilter } = this.state;

    if (activeFilter !== filter) {
      this.setState({ activeFilter: filter });
      this.onFetchData(this.table.current.state, null, filter);
    }
  }

  onModalClose(e) {
    e.preventDefault();
    this.setState({
      modalOpen: false,
      modalData: null,
    });
  }

  onModalOpen(e, data) {
    e.preventDefault();
    this.setState({
      modalOpen: true,
      modalData: data,
    });
  }

  onDelete(e, id) {
    e.preventDefault();
    const dealerId = this.props.id;
    this.setState({
      loading: true,
      modalOpen: false,
    });
    const data = {
      salesperson_id: id,
      dealer_id: dealerId,
      status: 2,
    };

    axios
      .put(`/salespeople/${id}/`, data)
      .then((res) => {
        this.setState({
          reqResponse: {
            header: "Salesperson Removed!",
            success: true,
          },
          modalData: null,
        });

        setTimeout(() => {
          this.setState({ reqResponse: null });
          this.onFetchData(this.table.current.state, this.table.current);
        }, 3000);
      })
      .catch((err) => {
        this.setState({
          loading: false,
          modalData: null,
          reqResponse: {
            header: "There was a problem",
            success: false,
            content: err.response.data.ui_message,
          },
        });

        setTimeout(() => {
          this.setState({ reqResponse: null });
          this.onFetchData(this.table.current.state, this.table.current);
        }, 3000);
      });
  }

  onFetchData(state, instance, activeFilter = this.state.activeFilter) {
    const { page, pageSize, sorted, filtered } = state;
    const dealerId = this.props.id;

    this.setState({ loading: true });

    filtered.forEach((filter) => {
      let filteredObject = "";

      switch (filter.id) {
        case "first_name":
          filteredObject = "self";
          break;
        case "last_name":
          filteredObject = "self";
        default:
          break;
      }

      filter.object = filteredObject;
    });

    const fetchRoute = "/retrieve-salespeople/";

    axios
      .post(fetchRoute, {
        page: page * pageSize,
        page_size: pageSize,
        sorted,
        filtered,
        status: activeFilter,
        dealer_id: dealerId,
      })
      .then((res) => {
        let numPages = 0;

        if (res.data.total < pageSize) {
          numPages = 1;
        } else {
          numPages = Math.ceil(res.data.total / pageSize);
        }

        this.setState({
          tableData: res.data.data,
          pages: numPages,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: {
            message: err.response.data.ui_message,
          },
        });
      });
  }

  render() {
    const { tableData, loading, error, activeFilter, pages, reqResponse } =
      this.state;

    let filterText = "";

    const entityText = "Salespeople";

    switch (activeFilter) {
      case 0:
        filterText = "Active";
        break;
      case 1:
        filterText = "Inactive";
        break;
      default:
        filterText = "";
        break;
    }

    const filterButtons = [
      { text: "Active", value: 0, color: "green" },
      { text: "Inactive", value: 1, color: "red" },
    ];

    if (error) {
      return (
        <Segment>
          <Message
            negative
            icon="exclamation"
            header="There was a problem loading salespeople"
            content={error.message}
          />
        </Segment>
      );
    }

    return (
      <Segment padded>
        <DeleteModal
          data={this.state.modalData}
          open={this.state.modalOpen}
          onModalClose={this.onModalClose}
          onDelete={this.onDelete}
        />
        <div>
          <TableFilterButtons
            activeFilter={activeFilter}
            onFilterButtonClick={this.onFilterButtonClick}
            buttons={filterButtons}
            loading={loading}
          />
          <Divider hidden />
          {reqResponse ? (
            <Message
              header={reqResponse.header}
              icon={reqResponse.success ? "check" : "exclamation"}
              positive={reqResponse.success ? true : false}
              error={!reqResponse.success ? true : false}
              content={reqResponse.content}
            />
          ) : null}
          <ReactTable
            data={tableData}
            columns={[
              {
                Header: "",
                width: 50,
                id: "view",
                sortable: false,
                filterable: false,
                accessor: (d) => {
                  return (
                    <div>
                      <Button
                        to={`/dealer/salespeople/${d.id}`}
                        as={Link}
                        size="mini"
                        icon="eye"
                        basic
                      />
                    </div>
                  );
                },
              },
              {
                Header: "First Name",
                accessor: "first_name",
              },
              {
                Header: "Last Name",
                accessor: "last_name",
              },
              {
                Header: "Email",
                accessor: "email",
                filterable: false,
              },
              {
                Header: "Phone",
                accessor: "phone",
                filterable: false,
              },
              {
                Header: "",
                width: 50,
                id: "actions",
                sortable: false,
                filterable: false,
                accessor: (d) => {
                  return (
                    <div>
                      <Button
                        icon="trash"
                        size="mini"
                        basic
                        negative
                        title="Delete"
                        className="icon-button"
                        onClick={(e) => this.onModalOpen(e, d)}
                      />
                    </div>
                  );
                },
              },
            ]}
            defaultPageSize={10}
            filterable
            minRows={5}
            className="-ui -striped -table"
            noDataText={`No ${filterText} ${entityText} Available`}
            loadingText={`Loading ${filterText} ${entityText}...`}
            loading={loading}
            rowsText={`${filterText} ${entityText}`}
            multisort={false}
            manual
            pages={pages}
            onFetchData={this.onFetchData}
            ref={this.table}
            PreviousComponent={prevButton}
            NextComponent={nextButton}
          />
        </div>
      </Segment>
    );
  }
}
